import { z } from "zod";

import { createRequiredMessage, HALF_WIDTH_NUMBER_FORMAT_MESSAGE } from "./message";
import { HALF_WIDTH_NUMBER_REGEX } from "./patterns";

// 共通のenum定義（APIの値に合わせる）
export const SIMULATION_MODE_VALUES = ["Percentage", "Real"] as const;
export const SIMULATION_SIGN_VALUES = ["positive", "negative"] as const;

export const simulationModeSchema = z.enum(SIMULATION_MODE_VALUES);
export const simulationSignSchema = z.enum(SIMULATION_SIGN_VALUES);

// 型定義
export type SimulationMode = z.infer<typeof simulationModeSchema>;
export type SimulationSign = z.infer<typeof simulationSignSchema>;

export const simulationConfigPriceLoanSchema = z.object({
  market_price_change_down_value: z
    .string()
    .min(1, createRequiredMessage())
    .regex(HALF_WIDTH_NUMBER_REGEX, HALF_WIDTH_NUMBER_FORMAT_MESSAGE),
  market_price_mode: simulationModeSchema,
  market_price_mode_sign: simulationSignSchema,
  market_price_change_at_bought_value: z
    .string()
    .min(1, createRequiredMessage())
    .regex(HALF_WIDTH_NUMBER_REGEX, HALF_WIDTH_NUMBER_FORMAT_MESSAGE),
  market_price_change_at_bought_mode: simulationModeSchema,
  market_price_change_at_bought_sign: simulationSignSchema,
});

export const simulationConfigBalanceSchema = z.object({
  house_rent_spare_months_for_N_contracts: z
    .string()
    .min(1, createRequiredMessage())
    .regex(HALF_WIDTH_NUMBER_REGEX, HALF_WIDTH_NUMBER_FORMAT_MESSAGE),
  house_rent_spare_months: z
    .string()
    .min(1, createRequiredMessage())
    .regex(HALF_WIDTH_NUMBER_REGEX, HALF_WIDTH_NUMBER_FORMAT_MESSAGE),
  house_rent_price_change_down_value: z
    .string()
    .min(1, createRequiredMessage())
    .regex(HALF_WIDTH_NUMBER_REGEX, HALF_WIDTH_NUMBER_FORMAT_MESSAGE),
  house_rent_mode: simulationModeSchema,
  house_rent_sign: simulationSignSchema,
  house_rent_price_change_ends_at: z
    .string()
    .min(1, createRequiredMessage())
    .regex(HALF_WIDTH_NUMBER_REGEX, HALF_WIDTH_NUMBER_FORMAT_MESSAGE),
  // 現在UIはコメントアウト中の項目
  reserve_fund_price_changes: z
    .array(
      z.object({
        month: z.string().min(1, createRequiredMessage()),
        amount: z
          .string()
          .min(1, createRequiredMessage())
          .regex(HALF_WIDTH_NUMBER_REGEX, HALF_WIDTH_NUMBER_FORMAT_MESSAGE),
      })
    )
    .optional(),
  income_tax_rate: z
    .string()
    .min(1, createRequiredMessage("所得税率"))
    .regex(HALF_WIDTH_NUMBER_REGEX, HALF_WIDTH_NUMBER_FORMAT_MESSAGE),
});

export type SimulationConfigPriceLoanFormData = z.infer<typeof simulationConfigPriceLoanSchema>;
export type SimulationConfigBalanceFormData = z.infer<typeof simulationConfigBalanceSchema>;
